import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { RestService } from './rest.service';
import Swal from 'sweetalert2';
import { $themeConfig } from 'src/app/core/theme.config';

@Injectable({
  providedIn: 'root',
})
export class AuthService {

private isAuthenticated: boolean = false;
// Inicialização de userRoles como array vazio
private userRoles: string[] = [];

  REST_ROOT = $themeConfig.restRoot;

  users = {
    id: '',
    firstname: '',
    lastname: '',
    username: '',
    email: '',
    mustChangePassword: false,
    role: '',
    date: '',
    lastAccessedAt: '',
    department: '',
    picture: ''
  };

  redirectUrl!: string;

  constructor(
    private router: Router,
    private location: Location,
    private restService: RestService
  ) {}

  isAuthenticatedUser(): boolean {
    //console.log("this.isAuthenticated",this.isAuthenticated)
    return this.isAuthenticated;
  }

  login(email: any, password: any): void {
    this.restService
      .createService(`${this.REST_ROOT}login`, { email, password })
      .pipe(
        tap((user) => {
          localStorage.setItem('token', user.token);
          this.users = {
            id: user.Id,
            firstname: user.FirstName,
            lastname: user.LastName,
            username: user.Username,
            email: user.Email,
            mustChangePassword: user.MustChangePassword,
            role: user.Role,
            date: user.date,
            lastAccessedAt: user.LastAccessedAt,
            department: user.Department,
            picture: user.Picture
          };
          this.userRoles = user.Role ? user.Role.split(',') : [];
          this.isAuthenticated = true;
          this.storeUserData(this.users);
          if (this.users.mustChangePassword) {
            this.changePasswordConfirmation();
          } else {
            this.router.navigate(this.redirectUrl ? [this.redirectUrl] : ['/dashboard']);
          }
        }),
        catchError((error) => {
          this.handleLoginError(error);
          return throwError(error);
        })
      )
      .subscribe();
  }

  hasAnyRole(roles: string[]): boolean {
    //console.log("roles >>>", roles)
    if (!Array.isArray(this.userRoles)) {
      this.userRoles = [];
    }
    return roles.some(role => this.userRoles.includes(role));
  }

  logout(): void {
    this.isAuthenticated = false;
    localStorage.clear(); // Simplifying clearing of local storage
  }

  private storeUserData(user: any): void {
    Object.keys(user).forEach(key => localStorage.setItem(key, user[key] ?? ''));
  }

  private changePasswordConfirmation() {
    Swal.fire({
      title: 'Update Password',
      text: `${this.users.firstname} ${this.users.lastname}, Your password is temporary and needs to be changed. Would you like to continue?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        this.router.navigate(['/auth/change-password']); // Example change-password route
      } else {
        window.location.reload();
      }
    });
  }

  private handleLoginError(error?: any): void {
    if (error && error.status === 403) {
        Swal.fire({
          title: 'Disabled Account',
          text: 'Your account has been disabled, please contact the system administrator.',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
    } else if (error && error.status === 401) {
        Swal.fire({
          title: 'Invalid access data!',
          text: 'Check your username and password.',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
    } else if (error && error.status === 404) {
        Swal.fire({
            title: 'Unauthorized',
            text: `This user does not exist, please request authorization from your area manager.`,
            icon: 'error',
            confirmButtonText: 'Ok'
        });
    } else if (error && error.status === 0) {
        Swal.fire({
          title: 'Server OffLine',
          text: 'Unable to establish a connection with the server ' + this.REST_ROOT,
          icon: 'error',
          confirmButtonText: 'Ok'
        });
        this.router.navigate(['/auth/login']);
    } else {
        Swal.fire({
          title: 'Invalid access data!',
          text: 'Check your username and password.',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
    }
  }
}
